/**
 * auth_banner_later.ts — "Later" on the Secure-your-account banner is remembered for the day (client sweep G9, PURE).
 * The banner re-appeared on every load for an unclaimed legacy account; a dismissal now holds until the next local day.
 */
export const BANNER_LATER_KEY = 'atlas:auth-banner-later';

/** The local calendar day as YYYY-MM-DD. */
export function dayStamp(now: Date): string {
  const p = (n: number): string => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${p(now.getMonth() + 1)}-${p(now.getDate())}`;
}

/** Was "Later" pressed today? `stored` is what localStorage held (any garbage reads as "no"). */
export function laterHoldsToday(stored: string | null, now: Date): boolean {
  return typeof stored === 'string' && stored === dayStamp(now);
}
